import React, { createContext, useContext, useState, useMemo } from 'react';

interface FinOpsTabContextType {
	activeTab: number;
	setActiveTab: (index: number) => void;
	filterMonth: string;
	setFilterMonth: (val: string) => void;
	timezone: string;
	setTimezone: (val: string) => void;
	filterCustomStartDate: Date | null;
	setFilterCustomStartDate: (val: Date | null) => void;
	filterCustomEndDate: Date | null;
	setFilterCustomEndDate: (val: Date | null) => void;
	hasFilters: boolean;
	setHasFilters: (val: boolean) => void;
	onFiltersOpen: () => void;
	setOnFiltersOpen: (fn: () => void) => void;
}

const FinOpsTabContext = createContext<FinOpsTabContextType>({
	activeTab: 0,
	setActiveTab: () => {},
	filterMonth: 'today',
	setFilterMonth: () => {},
	timezone: 'CST',
	setTimezone: () => {},
	filterCustomStartDate: null,
	setFilterCustomStartDate: () => {},
	filterCustomEndDate: null,
	setFilterCustomEndDate: () => {},
	hasFilters: false,
	setHasFilters: () => {},
	onFiltersOpen: () => {},
	setOnFiltersOpen: () => {},
});

export const useFinOpsTab = () => useContext(FinOpsTabContext);

export const FinOpsTabProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const [activeTab, setActiveTab] = useState(0);
	const [filterMonth, setFilterMonth] = useState('today');
	const [timezone, setTimezone] = useState('CST');
	const [filterCustomStartDate, setFilterCustomStartDate] = useState<Date | null>(null);
	const [filterCustomEndDate, setFilterCustomEndDate] = useState<Date | null>(null);
	const [hasFilters, setHasFilters] = useState(false);
	const [onFiltersOpen, setOnFiltersOpenState] = useState<() => void>(() => () => {});
	const setOnFiltersOpen = (fn: () => void) => setOnFiltersOpenState(() => fn);
	const value = useMemo(() => ({
		activeTab, setActiveTab,
		filterMonth, setFilterMonth, 
		timezone, setTimezone,
		filterCustomStartDate, setFilterCustomStartDate,
		filterCustomEndDate, setFilterCustomEndDate,
		hasFilters, setHasFilters,
		onFiltersOpen, setOnFiltersOpen,
	}), [activeTab, filterMonth, timezone, filterCustomStartDate, filterCustomEndDate, hasFilters, onFiltersOpen]);
	return (
		<FinOpsTabContext.Provider value={value}>
			{children}
		</FinOpsTabContext.Provider>
	);
};
